export interface HeaderCrumb {
    id: string;
    label: string;
}

export type HeaderTabId = 'accounts' | 'documents' | 'adjustments' | 'openItems' | 'comments';

export interface HeaderTab {
    id: HeaderTabId;
    count?: number | null;
}

export interface HeaderActionsSection {
    /**
     * When the ERP was last pulled. `null` when it never was — the button then shows no sub-line at
     * all, rather than a placeholder that reads like a real timestamp.
     */
    lastSync?: string | Date | null;
    /**
     * The connected vendor's logo and name, for the button.
     *
     * Both or neither: the logo carries an `alt`, and a picture of an accounting system with no name
     * behind it is worse than no picture. `null` when nothing is connected — the button then says
     * only what it does.
     */
    erpVendor?: { logoSrc: string; name: string } | null;
}

export interface HeaderTabsSection {
    items: HeaderTab[];
    activeId?: HeaderTabId | null;
}

export interface HeaderSections {
    path?: HeaderCrumb[];
    /**
     * The back button left of the path: where it leads, named like that crumb. Clicking it emits
     * `crumbSelect` with its id, so the host navigates the same way as for the crumb. Absent = no button.
     */
    back?: HeaderCrumb | null;
    actions?: HeaderActionsSection;
    tabs?: HeaderTabsSection;
}
